module.exports = __webpack_public_path__ + "img/methodGreen.1bb80bb7.jpg";